import { AppRoutes } from '@constants/app-routes'
import { Link } from '@ui/links/Link'

const baseUrl = '/images/cases/platform-for-improving-diagnostic-accuracy'

export const config = {
  headerTitle: 'Project execution',
  hexagonGrayFilled: {
    width: 420,
    height: 420,
    src: `${baseUrl}/hexagonGrayFilled.webp`,
    alt: 'Hexagon',
    title: 'Hexagon',
  },
  cards: [
    {
      id: 1,
      isRowReverse: true,
      textWidth: 664,
      title: 'Collaborative approach',
      text: (
        <>
          As soon as our senior-level engineers were incorporated into the
          client’s team, the active part of the software platform development
          was launched. To ensure seamless and transparent workflow,{' '}
          <Link href={AppRoutes.scaleYourTeam}>Modsen experts</Link> interacted
          with the rest of the team via our partner’s communication channel
          monday.com to participate in weekly meetups and retrospective calls,
          and to constantly keep in touch to instantly address challenges and
          discuss emerging issues. Our team quickly adapted to the internal
          company requirements and was welcome to implement the best software
          development practices.
        </>
      ),
      image: {
        src: `${baseUrl}/collaborative-approach.webp`,
        alt: 'Collaborative approach',
        title: 'Collaborative approach',
        width: 255,
        height: 255,
      },
      imageMobile: {
        src: `${baseUrl}/collaborative-approach.webp`,
        alt: 'Collaborative approach',
        title: 'Collaborative approach',
        width: 255,
        height: 255,
      },
    },
    {
      id: 2,
      isRowReverse: false,
      textWidth: 664,
      title: 'Domain expertise',
      text: 'Given the broad experience of our engineers in the incorporation of AI technology for MedTech, they managed to avert numerous roadblocks, specifically those related to regulatory compliance with European and universal healthcare software and data security standards. The collaborative approach, advanced communicative skills, and out-of-the-box thinking allowed Modsen augmentation team to streamline the development process and optimize resource allocation.',
      image: {
        src: `${baseUrl}/domain-expertise.webp`,
        alt: 'Domain expertise',
        title: 'Domain expertise',
        width: 256,
        height: 255,
      },
      imageMobile: {
        src: `${baseUrl}/domain-expertise.webp`,
        alt: 'Domain expertise',
        title: 'Domain expertise',
        width: 256,
        height: 255,
      },
    },
    {
      id: 3,
      isRowReverse: true,
      textWidth: 664,
      title: ' Flexibility and scalability',
      text: (
        <>
          In the course of project development, the team felt the need to scale
          up by incorporating another Modsen AI developer closely familiar with
          compiling comprehensive patient diagnosing and treatment databases to
          accelerate the launch of our partner’s final product. The engineer
          joined the project team at once, bringing extra insights and
          expertise, making the AI-based platform under development even more
          powerful, accurate, and secure.
          <br />
          As the active software building process phase was coming to an end,
          our partner decided to scale the outstaffed team down to 2 developer
          engineers and 1{' '}
          <Link href={AppRoutes.qualityAssurance}>QA tester</Link> who kept the
          workflow going after the product launch and have been continuing to do
          so.
        </>
      ),
      image: {
        src: `${baseUrl}/flexibility-and-scalability.webp`,
        alt: 'Flexibility and scalability',
        title: 'Flexibility and scalability',
        width: 249,
        height: 263,
      },
      imageMobile: {
        src: `${baseUrl}/flexibility-and-scalability.webp`,
        alt: 'Flexibility and scalability',
        title: 'Flexibility and scalability',
        width: 249,
        height: 263,
      },
    },
    {
      id: 4,
      isRowReverse: false,
      textWidth: 664,
      title: 'Versability',
      text: (
        <>
          The ultimate goal of our German client was to find a highly-skilled,
          experienced, and flexible team augmentation vendor, whose developer
          specialists would be adaptable and versatile. Modsen professionals
          selected for building a complex{' '}
          <Link href={AppRoutes.partnership}> AI solution for healthcare</Link>{' '}
          were also tasked with writing clear technical documentation in the
          style, accepted by the partner company specialists, and crafting a
          series of varied tests for the platform's performance comprehensive
          examination.
        </>
      ),
      image: {
        src: `${baseUrl}/versatility.webp`,
        alt: 'Versability',
        title: 'Versability',
        width: 259,
        height: 255,
      },
      imageMobile: {
        src: `${baseUrl}/versatility.webp`,
        alt: 'Versability',
        title: 'Versability',
        width: 259,
        height: 255,
      },
    },
  ],
}
